import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-closure-grid',
  templateUrl: './account-closure-grid.component.html',
  styleUrls: ['./account-closure-grid.component.css']
})
export class AccountClosureGridComponent implements OnInit {
  title="Account Closure List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/account-closure-grid/account-closure-grid.component.ts